module.exports = {
  platform: 'voice',
  name: 'Exit',
  node: 'exit',
  bg: '#FFFFFF',
  note: ''
}
